import api from '../axios'


export default {
  getAllStaff: () => api.get('/admin/staff'),
}
